import NavBar from '../components/common/NavBar';
import NewHeaderComponent from '../components/common/NewHeaderComponent';

export default function Subscribe(): JSX.Element | null {
    return (
        <div className="grid h-full overflow-x-auto overflow-y-hidden grid-cols-queueGrid min-w-840 undefined">
            <NavBar />
            <div className="flex flex-col h-full col-span-11 overflow-hidden">
                <NewHeaderComponent title="Subscribe to premium" />
                <iframe
                    height="100%"
                    width="100%"
                    src="https://eka.care/eka-doc-plans/pro-plan?fixedPlan=true&utm_source=doctool"
                ></iframe>
            </div>
        </div>
    );
}
